import { useEffect } from "react";
import { cn } from "tailwind-variants";
import { isProduction } from "common/utils/env";
import { readCookie } from "common/utils/cookie";
import { useDtfStore } from "./store";

export default function GangSheetBuilder({ ...restProps }) {
  const dtfStore = useDtfStore();

  function gangSheetBuilder() {
    return dtfStore.gangSheetBuilder;
  }

  function gangSheetBuilderShopId() {
    return dtfStore.gangSheetBuilderShopId;
  }

  function gangSheetBuilderSizes() {
    return dtfStore.gangSheetBuilderSizes;
  }

  function builderPayload() {
    const payload = {
      container: "gs-builder",
      mode: isProduction ? "production" : "development",
      shop_id: gangSheetBuilderShopId(),
      size_id: 3,
      sizes: gangSheetBuilderSizes(),
      settings: {
        nameAndNumber: {
          enabled: true
        }
      }
    };
    const customerId = readCookie("gangsheet_builder_customer_id");
    console.log("[GangSheetBuilder] <", customerId, ">");
    if (customerId) {
      payload.customer = {
        id: customerId
      };
    }
    return payload;
  }

  function setShowGangSheetBuilder(...args) {
    return dtfStore.setShowGangSheetBuilder(...args);
  }

  function setGeneratedGangSheets(...args) {
    return dtfStore.setGeneratedGangSheets(...args);
  }

  function addFilesToQueue(...args) {
    return dtfStore.addFilesToQueue(...args);
  }

  function showBuilder() {
    gangSheetBuilder()
      .open(builderPayload())
      .on("design:created", gangSheetData => {
        processGangSheet(gangSheetData.data);
        gangSheetBuilder().close();
        setShowGangSheetBuilder(false);
      })
      .on("closed", () => {
        setShowGangSheetBuilder(false);
      });
  }

  async function processGangSheet(gangSheetData) {
    const { designs } = gangSheetData;
    setGeneratedGangSheets(designs);
    const gangSheets = await Promise.all(
      designs.map(async design => {
        const downloadedGangSheet = await downloadGangSheetPreview(design);
        if (downloadedGangSheet) {
          return new File([downloadedGangSheet], `${design.id}.png`, {
            type: "image/png"
          });
        }
        return null;
      })
    );
    addFilesToQueue({
      files: gangSheets,
      artworkIndex: null,
      existingArtworkId: null
    });
  }

  async function downloadGangSheetPreview(design) {
    let downloadedGangSheet = null;
    try {
      const response = await fetch(design.thumbnail_url);
      downloadedGangSheet = await response.blob();
    } catch (error) {
      /* TODO(vue-migration): this.$store and this.$analytics are Vue injected globals; use React equivalent notifier and analytics service */
      // notifier.error({
      //   message: "Failed to download gang sheet preview",
      //   error
      // });
      // analytics.trackError("GangSheetPreviewDownloadError", error);
    }
    return downloadedGangSheet;
  }
  useEffect(() => {
    showBuilder();
  }, []);

  return (
    <div
      {...restProps}
      className={cn("modal gang-sheet-builder-modal", restProps.className)}
      id="gang-sheet-builder-modal-body"
      data-testid="modal"
    />
  );
}
